// extracted by mini-css-extract-plugin
export var colorSquare = "_um-0";
export var danger = "_um-5";
export var lightPink = "_um-8";
export var neutralBlue = "_um-7";
export var neutralYellow = "_um-6";
export var normal = "_um-1";
export var primary = "_um-2";
export var primaryLight = "_um-3";
export var solidBlack = "_um-g";
export var solidGreen = "_um-b";
export var solidLightBlue = "_um-d";
export var solidNavy = "_um-c";
export var solidOrange = "_um-f";
export var solidPink = "_um-e";
export var solidRed = "_um-9";
export var solidYellow = "_um-a";
export var success = "_um-4";